/* Social proof toast notifications */
(function () {
  'use strict';

  var config = window.INTIMUM_SOCIAL_PROOF;
  if (!config || !config.enabled || !config.data || config.data.length === 0) return;

  var toast = document.getElementById('social-proof-toast');
  var toastImg = document.getElementById('sp-toast-img');
  var toastText = document.getElementById('sp-toast-text');
  var toastTime = document.getElementById('sp-toast-time');
  var toastClose = document.getElementById('sp-toast-close');

  if (!toast) return;

  var currentIndex = 0;
  var isVisible = false;

  function showToast() {
    if (isVisible) return;

    var item = config.data[currentIndex];
    currentIndex = (currentIndex + 1) % config.data.length;

    toastText.innerHTML = 'Alguém em <strong>' + item.city + '</strong> comprou <strong>' + item.product + '</strong>';
    toastTime.textContent = 'há ' + item.time;

    if (item.image) {
      toastImg.src = item.image;
      toastImg.style.display = '';
    } else {
      toastImg.style.display = 'none';
    }

    toast.classList.add('is-visible');
    isVisible = true;

    setTimeout(hideToast, config.duration);
  }

  function hideToast() {
    toast.classList.remove('is-visible');
    isVisible = false;
  }

  toastClose?.addEventListener('click', function () {
    hideToast();
  });

  // Start after initial delay
  var initialDelay = 8000;
  setTimeout(function () {
    showToast();
    setInterval(showToast, config.interval + config.duration);
  }, initialDelay);
})();
